import React from 'react'
import UnityMeasurements from './components/UnityMeasurements'
import UnitMeasurements from './components/UnityMeasurements'


function GetUnityMeasurements() {
  return (
    <UnitMeasurements />
  )
}

export default GetUnityMeasurements